const destinations = [
  {
    name: "Germany",
    context: "MTS Systems regulatory meetings, medical device conferences, and Munich trade shows",
    urgency: "Regulatory meeting schedules and trade shows are fixed with no flexibility",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom",
    context: "Financial services, technology partnerships, and direct MSP to London flights",
    urgency: "Corporate travel often has 10–21 day lead time from Eden Prairie offices",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Caribbean",
    context: "Family cruises, resort vacations, and spring break from MSP",
    urgency: "Last-minute cruise deals compress booking-to-departure timelines significantly",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Japan",
    context: "Technology partnerships, product launches, and Asia business assignments",
    urgency: "Product launch schedules are fixed — passport delays mean missed milestones",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada",
    context: "Toronto business, Ontario fishing trips, and Boundary Waters adjacent travel",
    urgency: "Summer travel peak runs May through September for Minnesota outdoor travelers",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Netherlands",
    context: "MSP direct to Amsterdam, European distribution connections, and heritage tourism",
    urgency: "Direct Amsterdam flights from MSP create high booking frequency for Minnesotans",
    icon: "ri-map-pin-2-line",
  },
];

const commonSituations = [
  {
    stat: "Top 10",
    label: "Eden Prairie consistently ranks in national lists of best places to work and raise a family",
  },
  {
    stat: "20 Min",
    label: "typical drive from Eden Prairie's corporate parks to MSP Terminal 1 via I-494",
  },
  {
    stat: "2–3 Weeks",
    label: "typical international travel notice period Eden Prairie corporate professionals receive",
  },
  {
    stat: "24 Hours",
    label: "fastest emergency passport turnaround for Eden Prairie travelers with urgent MSP departures",
  },
];

export default function EdenPrairieDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Eden Prairie Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Eden Prairie clients. Understanding local travel behavior is part of why our document review catches issues before they derail your business meeting, regulatory trip, or family vacation.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {commonSituations.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Minnesota Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Minnesota with the same expedited passport processing and document review expertise.
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              <a href="/minneapolis" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Minneapolis <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/plymouth-mn" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Plymouth <i className="ri-arrow-right-line text-xs"></i>
              </a>
              <a href="/bloomington" className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                Bloomington <i className="ri-arrow-right-line text-xs"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}